import { useEffect, useState } from "react";
import { organizerMeApi } from "../../api/api";
import { puedeCobrarSenas } from "../../helpers/senasOrganizer";

// Mientras carga, los controles de seña quedan deshabilitados para que no se pueda
// guardar nada a mitad de camino. Si el pedido falla se habilitan y decide el backend.
export default function useCobrosHabilitados() {
  const [estado, setEstado] = useState({ cargando: true, puedeCobrar: true });

  useEffect(() => {
    let activo = true;
    (async () => {
      let puedeCobrar = true;
      try {
        const res = await organizerMeApi();
        puedeCobrar = puedeCobrarSenas(res?.data?.info);
      } catch (_) {
        puedeCobrar = true;
      }
      if (activo) setEstado({ cargando: false, puedeCobrar });
    })();
    return () => {
      activo = false;
    };
  }, []);

  return estado;
}
